import { Base } from '../../abstract/base.model';
import { isRecord } from '../utils/is-record';
import { toStateReportOptions } from '../utils/report-wire-utils';
import { nullableNumber, nullableString } from '../utils/wire-value-utils';
import { StateReportOptions } from './state-report-options.model';
import { StateReportStatus } from './state-report-status.model';
import { StateReportType } from './state-report-type.model';

/**
 * A state compliance report as `/admin/state-reports` returns it (hub `data-models/state-report.ts`). Only the
 * dates are writable (PUT /admin/state-reports/:id); everything else is set by generation. A value the hub
 * didn't send stays `undefined`.
 */
export class StateReport extends Base {
  // Writable via PUT /admin/state-reports/:id (YYYY-MM-DD, as sent)
  startDate?: string | null;
  endDate?: string | null;

  // Read-only
  organizationId?: string | null;
  organizationName?: string | null;
  name?: string | null;
  /** 2-letter state code. */
  state?: string | null;
  reportType?: StateReportType | null;
  status?: StateReportStatus | null;
  options?: StateReportOptions;
  generationProgress?: number | null;
  recordCount?: number | null;
  fileSize?: string | null;
  reportUrl?: string | null;
  /** Pre-signed download URL; only on the detail of a ready report. */
  downloadUrl?: string | null;
  submittedAt?: string | null;
  submittedTo?: string | null;
  errorMessage?: string | null;

  constructor(data: unknown) {
    super(data);
    const source = isRecord(data) ? data : {};
    this.startDate = nullableString(source['startDate']);
    this.endDate = nullableString(source['endDate']);
    this.organizationId = nullableString(source['organizationId']);
    this.organizationName = nullableString(source['organizationName']);
    this.name = nullableString(source['name']);
    this.state = nullableString(source['state']);
    this.reportType = nullableString(source['reportType']) as StateReportType | null | undefined;
    this.status = nullableString(source['status']) as StateReportStatus | null | undefined;
    this.options = toStateReportOptions(source['options']);
    this.generationProgress = nullableNumber(source['generationProgress']);
    this.recordCount = nullableNumber(source['recordCount']);
    this.fileSize = nullableString(source['fileSize']);
    this.reportUrl = nullableString(source['reportUrl']);
    this.downloadUrl = nullableString(source['downloadUrl']);
    this.submittedAt = nullableString(source['submittedAt']);
    this.submittedTo = nullableString(source['submittedTo']);
    this.errorMessage = nullableString(source['errorMessage']);
  }
}
